<template>
  <section class="app-ecommerce-details">

    <!-- Alert: No item found -->
    <b-alert
      variant="danger"
      :show="product === undefined"
    >
      <h4 class="alert-heading">
        Error fetching product data
      </h4>
      <div class="alert-body">
        No item found with this item slug. Check
        <b-link
          class="alert-link"
          :to="{ name: 'home'}"
        >
          Shop
        </b-link>
        for other items.
      </div>
    </b-alert>

    <!-- Content -->
    <b-card
      v-if="product"
      no-body
    >
      <b-card-body>
        <b-row class="my-2">

          <!-- Left: Product Image Container -->
          <b-col
            cols="12"
            md="5"
            class="d-flex align-items-center justify-content-center mb-2 mb-md-0"
          >
            <div class="d-flex align-items-center justify-content-center">
              <b-img
                :src="product.imagens[0].caminho_imagem"
                :alt="`Image of ${product.item_nome}`"
                class="product-img"
                width="300px"
                fluid
              />
            </div>
          </b-col>

          <!-- Right: Product Details -->
          <b-col
            cols="12"
            md="7"
          >

            <!-- Product Name -->
            <h4>{{ product.item_nome }}</h4>

            <!-- Product Brand -->
            <b-card-text class="item-company mb-0">
              <b-link :to="{ name: 'app-admin-category-view', params: { id: product.categoria.id } }" class="company-name">
                {{ product.categoria.nome }}
              </b-link>
            </b-card-text>

            <!-- Price And Ratings -->
            <div class="ecommerce-details-price d-flex flex-wrap mt-1 ">
              <h4 class="item-price mr-1 text-success">
                R$ {{ parseFloat(product.tabela_preco_itens[0].preco_venda).toFixed(2) }}
              </h4>
            </div>

            <!-- Product Description -->
            <b-card-text class="mt-1" v-html="product.item_descricao"></b-card-text>
          </b-col>

          <b-col
              cols="12"
              md="12"
              class="mt-2"
          >
            <slider-items v-model="product.imagens" />
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
  </section>
</template>

<script>
import router from '@/router'
import store from '@/store'
import {onMounted, ref} from '@vue/composition-api'
import {
  BCard, BCardBody, BRow, BCol, BImg, BCardText, BLink, BAlert,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import SliderItems from '@/views/apps/produtos/details/SliderItems.vue';

export default {
  directives: {
    Ripple,
  },
  components: {
    SliderItems,
    // BSV
    BCard,
    BCardBody,
    BRow,
    BCol,
    BImg,
    BCardText,
    BLink,
    BAlert,
  },
  setup() {
    const product = ref(null)

    // Remote Data
    const fetchProduct = id => {
      store.dispatch('appAdmProdutos/findById', { id })
        .then(response => {
          product.value = response.data
          product.value.rating = Math.floor(Math.random() * 6)
        })
        .catch(error => {
          if (error.response.status === 404) {
            product.value = undefined
          }
        })
    }

    // UI
    const selectedColor = ref(null)

    onMounted(() => {
      if (typeof router.currentRoute.params.id !== 'undefined') {
        fetchProduct(router.currentRoute.params.id)
      }
    })

    return {

      // Fetched Product
      product,

      // UI
      selectedColor,
    }
  },
}
</script>

<style lang="scss">
@import "~@core/scss/base/pages/app-ecommerce-details.scss";
</style>
